module.exports = __webpack_public_path__ + "static/media/icon-behance.98d1b381.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-behance.svg
// module id = 514
// module chunks = 0